// This is a Statsig experiment
export const MACRO_INTERACTION_DESIGN_UPDATES = 'confluence_frontend_macro_interaction_design';
